import { createApp } from 'vue';
import vuetify from './plugins/vuetify.js';
import App from './App.vue';
import router from './app.routes';
import store from './app.store';
import { SWITCH_GOD_MODE } from './store/global.mutations.types';
import { version } from '../package.json';
import Config from '@/services/config.service';
import * as Sentry from '@sentry/vue';

console.info('Gamelearn Resources Manager Front ', version);

const app = createApp(App);

// do not use Sentry in development
if (Config.environment !== 'local') {
  Sentry.init({
    app,
    dsn: 'https://b08d418b070947058fc64735ad56e5dc@o436063.ingest.sentry.io/5402648',
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.Replay(),
    ],
    environment: Config.environment,
  });
  window.Sentry = Sentry;
}

let godModeBuffer = '1234567';
document.addEventListener('keydown', (event) => {
  const key = event.key.toLowerCase();
  godModeBuffer += key;
  godModeBuffer = godModeBuffer.slice(godModeBuffer.length - 7);
  if (godModeBuffer === 'godmode') {
    store.dispatch(SWITCH_GOD_MODE);
  }
});

app.use(router);
app.use(store);
app.use(vuetify);
app.mount('#app');
